module.exports = "/assets/data/a50bf698e349160c561e65d9cae538a7-SP8.data.json";